export function colorFor(key: string): string {
  const colors = ['#5E8AB4', '#4E8780', '#FFA267', '#F05F5E', '#60B8B0', '#3F5D7A'];
  let hash = 0;
  for (let i = 0; i < key.length; i += 1) hash = (hash * 31 + key.charCodeAt(i)) | 0;
  return colors[Math.abs(hash) % colors.length];
}
